/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ConstructStaticMapUrlRequest,
  ConstructStaticMapUrlResponse,
  LocationDto,
  LocationWithAddressDto,
  SearchParams,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiLocationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-location-controller
   * @name SignStaticMapUrl
   * @request POST:/api/v1/location/sign-static-map-url
   */
  signStaticMapUrl = (data: ConstructStaticMapUrlRequest, params: RequestParams = {}) =>
    this.http.request<ConstructStaticMapUrlResponse, any>({
      path: `/v1/location/sign-static-map-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static signStaticMapUrlPath = '/v1/location/sign-static-map-url'
  static signStaticMapUrlMethod = 'POST'
  /**
   * No description
   *
   * @tags api-location-controller
   * @name SearchByPlaceId
   * @request GET:/api/v1/location/{placeId}
   */
  searchByPlaceId = (placeId: string, params: RequestParams = {}) =>
    this.http.request<LocationWithAddressDto, any>({
      path: `/v1/location/${placeId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static searchByPlaceIdPath = '/v1/location/${placeId}'
  static searchByPlaceIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-location-controller
   * @name Search
   * @request GET:/api/v1/location/search
   */
  search = (query: SearchParams, params: RequestParams = {}) =>
    this.http.request<LocationDto[], any>({
      path: `/v1/location/search`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static searchPath = '/v1/location/search'
  static searchMethod = 'GET'
}
